// Helpers.
import { queryToObject } from "utils";

// Allows to use <a/> tags as active-buttons with parameters in "href" attribute.
//
// USAGE:
//
// <a href="#subject?option1=A&option2=B">MyLink</a>
//
// const ac = anchorCatch("selector");
//
// ac.catch("subject", (options, element) => {
//   console.log(options); // {option1: "A", option2: "B"}
// });
//
export default function anchorCatch(selector) {
  const handlers = {};
  const root = selector instanceof HTMLElement
    ? selector
    : document.querySelector(selector);

  function intercept(event) {
    if (!isValidAnchor(event.target)) return;
    const [subject, options] = extractSubjectAndOptions(event.target.href);
    handlers[subject] && handlers[subject](options, event.target);
    event.preventDefault();
  }

  root && root.addEventListener("click", intercept);

  return {
    catch: (subject, callback) => {
      if (typeof subject === "string" && typeof callback === "function") {
        handlers[subject] = callback;
      }
    },
    destroy: () => {
      root && root.removeEventListener("click", intercept);
      Object.keys(handlers).forEach(key => delete handlers[key]);
    },
  };
}

// ---- Helpers ----------------

function isValidAnchor(element) {
  return element.nodeName === "A" && element.href && element.href.includes("#");
}

function extractSubjectAndOptions(href) {
  const index = href.indexOf("#");
  const params = href.slice(index + 1).split("?");
  const options = params[1] ? queryToObject(`?${params[1]}`) : undefined;
  return [params[0], options];
}
